<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";

  export let klass = "";
  let loading = false;
  let lpInquiryWebhook = "";
  let id = 0;

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/webhooks");
    console.log(data);

    data.webhooks.forEach((w) => {
      if (w.masterWebhook.label === "LP問い合わせ") {
        lpInquiryWebhook = w.url;
        id = w.id;
      }
    });
  });

  const handleLpInquiryWebhookUrl = (event) => {
    lpInquiryWebhook = event.detail.value;
  };

  const saveLpInquiryWebhook = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.post("/webhook", {
      id,
      webhookId: 2,
      name: "LP問い合わせ",
      url: lpInquiryWebhook,
    });
    console.log(data);
    loading = false;
  };

  const testLpInquiryWebhook = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.get("/webhook/send/2");
    console.log(data);
    loading = false;
  };
</script>

<SectionBoard {klass}>
  <h2 class="font-semibold">Webhook設定</h2>

  <div class="mt-6">
    <FormWithLabel
      label="LP問い合わせ"
      placeholder=""
      input={handleLpInquiryWebhookUrl}
      value={lpInquiryWebhook}
    />
  </div>

  <BlueButton rounded klass="mt-4" click={saveLpInquiryWebhook} {loading}
    >更新する</BlueButton
  >

  <BlueButton rounded klass="mt-4 w-40" click={testLpInquiryWebhook} {loading}
    >テスト送信する</BlueButton
  >
</SectionBoard>
